/**
 * Returns the best available project image URL, falling back to placeholder.
 * Shared utility used across Dashboard, ProjectDetail, and ProjectConfigModal.
 *
 * @param {Object} project - The project object
 * @param {string} size - 'thumbnail' | 'medium' | 'original'
 * @param {string} apiBase - Backend API base URL
 * @returns {string} Image URL
 */
export function getProjectImageUrl(project, size = 'medium', apiBase) {
  if (project?.projectImageCloudinary?.urls) {
    return project.projectImageCloudinary.urls[size]
      || project.projectImageCloudinary.urls.medium
      || project.projectImageCloudinary.urls.original;
  }
  if (project?.projectImage) {
    return `${apiBase}${project.projectImage}`;
  }
  return `${apiBase}/images/building-placeholder.png`;
}

/** Placeholder URL for project images */
export function getProjectPlaceholderUrl(apiBase) {
  return `${apiBase}/images/building-placeholder.png`;
}
